import React from 'react'
import { connect } from 'react-redux'
import SkonsolidowanePolaczenieSpolek from '../../components/DaneOrganizacyjne/SkonsolidowanePolaczenieSpolek'
import SkonsolidowanePolaczenieSpolekV12 from '../../components/DaneOrganizacyjne/SkonsolidowanePolaczenieSpolekV12'
import WewnetrzneJednostki from '../../components/DaneOrganizacyjne/WewnetrzneJednostki'
import ZalozenieKontynuacji from '../../components/DaneOrganizacyjne/ZalozenieKontynuacji'
import * as actions from '../../store/actions'
import DaneOrganizacyjneStyle from '../../styles/DaneOrganizacyjneStyle'
import MainStyle from '../../styles/MainStyle'
import SrednioroczneZatrudnienie from '../../components/DaneOrganizacyjne/SrednioroczneZatrudnienie'
import ObowiazekBadania from '../../components/DaneOrganizacyjne/ObowiazekBadania'

function SkonsolidowaneDaneOrganizacyjne({
  sectionList,
  onSetSectionDataArray,
  onSetSectionData,
  validityErrors,
  onDeleteDetail,
  onAddDetailInfo,
  czyPodsumowanie,
}) {
  return (
    <MainStyle>
      <DaneOrganizacyjneStyle>
        {sectionList.map((data, index) => {
          switch (data.TypSekcji) {
            case 'WewnetrzneJednostki':
            case 'WewnetrzneJednostki_r2' :
              return (
                <WewnetrzneJednostki
                  title="DANE ŁĄCZNE WEWNĘTRZNYCH JEDNOSTEK ORGANIZACYJNYCH"
                  label="Sprawozdania finansowe jednostek objętych skonsolidowanym sprawozdaniem finansowym zawierają dane łączne (jeżeli w skład jednostek powiązanych wchodzą wewnętrzne jednostki organizacyjne sporządzające samodzielne sprawozdania finansowe)"
                  key={index}
                  data={data.Dane}
                  onSetSectionData={(name, value) =>
                    onSetSectionData(name, value, index)
                  }
                />
              )
            case 'KontynuacjaDzialalnosci':
            case 'KontynuacjaDzialalnosci_r2':
              return (
                <ZalozenieKontynuacji
                  title="ZAŁOŻENIE KONTYNUACJI DZIAŁALNOŚCI PRZEZ JEDNOSTKI POWIĄZANE"
                  label1="Sprawozdania finansowe stanowiące podstawę do sporządzenia skonsolidowanego sprawozdania finansowego zostały sporządzone przy założeniu kontynuowania działalności gospodarczej przez jednostki powiązane w dającej się przewidzieć przyszłości"
                  label2="Istnieją okoliczności wskazujące na zagrożenie kontynuowania działalności przez jednostki powiązane"
                  key={index}
                  data={data.Dane}
                  errors={validityErrors.filter(
                    (value) => value.TypSekcji === data.TypSekcji,
                  )}
                  onSetSectionData={(name, value) =>
                    onSetSectionData(name, value, index)
                  }
                  czyPodsumowanie={czyPodsumowanie}
                />
              )
            case 'SkonsolidowanePolaczenieSpolek':
              return (
                <SkonsolidowanePolaczenieSpolek
                  sIndex={index}
                  key={index}
                  data={data.Dane}
                  errors={validityErrors.filter(
                    (value) => value.TypSekcji === data.TypSekcji,
                  )}
                  onSetSectionData={onSetSectionData}
                  onSetSectionDataArray={onSetSectionDataArray}
                  onDeleteDetail={onDeleteDetail}
                  onAddDetailInfo={onAddDetailInfo}
                  czyPodsumowanie={czyPodsumowanie}
                />
              )
            case 'SkonsolidowanePolaczenieSpolek_v1_2':
            case 'SkonsolidowanePolaczenieSpolek_r2':
              return (
                <SkonsolidowanePolaczenieSpolekV12
                  sIndex={index}
                  key={index}
                  data={data.Dane}
                  errors={validityErrors.filter(
                    (value) => value.TypSekcji === data.TypSekcji,
                  )}
                  onSetSectionData={onSetSectionData}
                  onSetSectionDataArray={onSetSectionDataArray}
                  onDeleteDetail={onDeleteDetail}
                  onAddDetailInfo={onAddDetailInfo}
                  czyPodsumowanie={czyPodsumowanie}
                />
              )
              case 'SrednioroczneZatrudnienie_r2':
                return (
                  <SrednioroczneZatrudnienie
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'ObowiazekBadania_r2':
                return (
                  <ObowiazekBadania
                    key={index}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )              
            default:
              return null
          }
        })}
      </DaneOrganizacyjneStyle>
    </MainStyle>
  )
}

const mapStateToProps = (state) => ({
  validityErrors: state.sprawozdanie.validityErrors
    ? state.sprawozdanie.validityErrors
    : [],
  czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
})

const mapDispatchToProps = (dispatch) => ({
  onSetSectionData: (name, value, index) => {
    dispatch(actions.setSectionData(name, value, index))
  },
  onSetSectionDataArray: (value, index, sIndex, name) => {
    dispatch(actions.setSectionDataArray(value, index, sIndex, name))
  },
  onDeleteDetail: (i, sI) => {
    dispatch(actions.deleteDetail(i, sI))
  },
  onAddDetailInfo: (structure, sIndex) => {
    dispatch(actions.addDetailInfo(structure, sIndex))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SkonsolidowaneDaneOrganizacyjne)
